import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MessageService } from '../message.service';
import { Router } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { Column, GridOption, AngularGridInstance, Formatters } from 'angular-slickgrid';
import { CustomInputEditor } from '../custom-inputEditor';
import { NotifierService } from 'angular-notifier';
import { RestApiService } from '../rest-api.service';
import { Subscription } from 'rxjs';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
    selector: 'app-auto-ticket-master',
    templateUrl: './auto-ticket-master.component.html',
    styleUrls: ['./auto-ticket-master.component.css']
})
export class AutoTicketMasterComponent implements OnInit, OnDestroy {
    description: string;
    clientId: number;
    ttypes = [];
    ticketSelected: number;
    ticketTypeId: number;
    categoryLoaded: boolean;
    private baseCategories = [];
    ticketTypes: any;
    cat = [];
    dynamicFields = [];
    priorityType: number;
    columnDefinitions = [];
    ticketType: string;
    ticket_status = [];
    activitySelected: number;
    ticketStatus: string;
    activityType: any;
    // activityValue: string;
    activityTypeName: string;
    ticketTitle: string;
    ticketDesc: string;
    activityValue: { value: string }[];
    activityTypeId: number;
    sunValue: { value: string }[];
    monValue: { value: string }[];
    tueValue: { value: string }[];
    wedValue: { value: string }[];
    thuValue: { value: string }[];
    friValue: { value: string }[];
    satValue: { value: string }[];
    time = [];
    // month: {value: string}[];
    month = [];
    day = [];

    sunChck: boolean;
    monChck: boolean;
    tueChck: boolean;
    wedChck: boolean;
    thurChck: boolean;
    friChck: boolean;
    satChck: boolean;

    sourceType: string;
    ticketTypeSeq: number;
    hideAddmore: boolean;
    priorityId = 0;
    priority: string;
    support_group = [];
    groupSelected: number;
    users = [];
    userSelected: number;
    allMonths = [];

    add: boolean;
    del: boolean;
    edit: boolean;
    view: boolean;
    displayData: any;

    isError = false;
    isError1 = false;
    errorMessage: string;
    respObject: any;
    totalData: number;
    nextOffset: number;
    previousOffset: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    private baseFlag: any;
    private userAuth: Subscription;
    private notifier: NotifierService;
    offset: number;
    userName: string;
    name: string;
    private disabledCount: number;
    allDays = [];
    allQuarter = [];
    quarterlyMonth = [];

    monthlyActivity = [{ 'month': 'Select month', 'date': 'Select day', 'time': '' }];
    quarterlyActivity = [{ 'quarter': 'Select quarter', 'month': 'Select month', 'date': 'Select date', 'time': '' }];
    allDate = [];
    dataLoaded: boolean;


    @ViewChild('openActivityValueDetail') private openActivityValueDetail;
    myModal: any;
    itemValue: any;
    value: any;
    value1: any;
    value2: any;
    value3: any;
    value4: any;
    value5: any;
    value6: any;
    adhocLoad: boolean;
    dailyLoad: boolean;
    weeklyLoad: boolean;
    monthlyLoad: boolean;
    quarterlyLoad: boolean;
    val: string;





    constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
        private modalService: NgbModal, notifier: NotifierService) {
        // this.messageService.getCellChangeData().subscribe(item => {});
        // console.log(JSON.stringify(item));

        this.activityValue = [{ value: '' }];
        this.sunValue = [{ value: '' }];
        this.monValue = [{ value: '' }];
        this.tueValue = [{ value: '' }];
        this.wedValue = [{ value: '' }];
        this.thuValue = [{ value: '' }];
        this.friValue = [{ value: '' }];
        this.satValue = [{ value: '' }];
        this.time = [];
        // this.month = [{value: ''}];
        this.month = [0];
        this.day = [0];
        this.allDate = Array(31).fill(0).map((x, i) => i + 1);

        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            // console.log("====================="+item);
            switch (item.type) {
                case 'change':
                    if (!this.messageService.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            item.createdBy = this.messageService.getUserId();
                            this._rest.editAutoTicket(item).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    // console.log('data--Done');
                                    this.notifier.notify('success', 'Updated successfully');
                                } else {
                                    // console.log('data--Not---Done');
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', JSON.stringify(err));
                            });
                        }
                    }
                    break;
                case 'delete':
                    // console.log('deleted');
                    if (!this.messageService.del) {
                        this.notifier.notify('error', 'You do not have delete permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            // console.log(JSON.stringify(item));
                            this._rest.deleteAutoTicket({ id: item.id, user_id: this.messageService.getUserId() }).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    this.messageService.sendAfterDelete(item.id);
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', JSON.stringify(err));
                            });
                        }
                    }
                    break;

                case 'showTicket':
                    // console.log(JSON.stringify(item));
                    // console.log(JSON.stringify(item.activity_value));
                    this.myModal = this.modalService.open(this.openActivityValueDetail, {});
                    this.itemValue = item;
                    // console.log("itemvalue"+JSON.stringify(this.itemValue));
                    // console.log("activity type"+this.itemValue.activity_type);

                    switch (item.activity_type) {

                        case 'Daily':
                            this.dailyLoad = true;
                            this.adhocLoad = false;
                            this.weeklyLoad = false;
                            this.monthlyLoad = false;
                            this.quarterlyLoad = false;

                            this.value2 = [];
                            this.val = 'Time' + ': ' + this.itemValue.activity_value;
                            this.value2.push(this.val);

                            // console.log("aaaaa"+this.value2);


                            break;
                        case 'Adhoc':

                            this.adhocLoad = true;
                            this.dailyLoad = false;
                            this.weeklyLoad = false;
                            this.monthlyLoad = false;
                            this.quarterlyLoad = false;
                            this.value2 = [];
                            const str = '' + this.itemValue.activity_value;
                            const arr = str.split(',');

                            this.val = 'Date' + ': ' + arr[0];
                            this.value2.push(this.val);
                            const val1 = 'Time' + ': ' + arr[1];
                            this.value2.push(val1);


                            break;

                        case 'Quarterly':
                            this.quarterlyLoad = true;
                            this.adhocLoad = false;
                            this.dailyLoad = false;
                            this.weeklyLoad = false;
                            this.monthlyLoad = false;

                            this.value = JSON.parse(item.activity_value);
                            this.value6 = this.value;

                            break;

                        case 'Weekly':
                            this.value = JSON.parse(item.activity_value);
                            this.weeklyLoad = true;
                            this.adhocLoad = false;
                            this.dailyLoad = false;
                            this.monthlyLoad = false;
                            this.quarterlyLoad = false;
                            this.value3 = [];
                            this.value4 = [];
                            for (let i = 0; i < 7; i++) {
                                for (var key in this.value[i]) {
                                    if (key !== 'time') {
                                        const string = '' + key;
                                        const str = string[0].toUpperCase() + string.slice(1);
                                        this.value3.push(str);
                                        this.val = '' + this.value[i].time;

                                        this.value4.push(this.val);
                                    }


                                }

                            }

                            break;

                        case 'Monthly':
                            //    console.log("aaaaaaaaaaaaaa");
                            this.value = JSON.parse(item.activity_value);
                            this.monthlyLoad = true;
                            this.adhocLoad = false;
                            this.dailyLoad = false;
                            this.weeklyLoad = false;
                            this.quarterlyLoad = false;
                            this.value5 = this.value;


                            break;

                    }


                    break;
            }
        });
    }

    ngOnInit() {
        this.dataLoaded = false;
      console.log('ngOnInit allDate==' + this.allDate);
        this.userSelected = 0;
        this.groupSelected = 0;
        this.hideAddmore = true;
        this.sunChck = false;
        this.monChck = false;
        this.tueChck = false;
        this.wedChck = false;
        this.thurChck = false;
        this.friChck = false;
        this.satChck = false;
        this.ticketDesc = '';
        this.ticketTitle = '';
        // this.activityValue = '';
        this.activitySelected = 0;
        this.activityType = [{ id: 0, activity: 'Select Activity Type' }, { id: 2, activity: 'Daily' }, { id: 3, activity: 'Weekly' },
        { id: 4, activity: 'Monthly' }, { id: 5, activity: 'Quarterly' }];

        this.allMonths = [{ id: 0, name: 'Select month' }, { id: -1, name: 'All' }, { id: 1, name: 'January' },
        { id: 2, name: 'February' }, { id: 3, name: 'March' }, { id: 4, name: 'April' }, { id: 5, name: 'May' }, { id: 6, name: 'June' },
        { id: 7, name: 'July' }, { id: 8, name: 'August' }, { id: 9, name: 'September' }, { id: 10, name: 'October' },
        { id: 11, name: 'November' }, { id: 12, name: 'December' }];
        this.allDays = [{ id: 0, name: 'Select day' }, { id: 1, name: 'Sunday' }, { id: 2, name: 'Monday' }, { id: 3, name: 'Tuesday' },
        { id: 4, name: 'Wednesday' }, { id: 5, name: 'Thursday' }, { id: 6, name: 'Friday' }, { id: 7, name: 'Saturday' }];
        this.allQuarter = [{ id: 0, name: 'Select quarter' }, { id: 1, name: 'Quarter1' },
        { id: 2, name: 'Quarter2' }, { id: 3, name: 'Quarter3' }, { id: 4, name: 'Quarter4' }];
        this.categoryLoaded = true;
        this.ticketSelected = 0;
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        this.displayData = {
            pageName: 'Maintain Auto Ticket',
            openModalButton: 'Add Auto Ticket Configuration',
            breadcrumb: 'Auto Ticket',
            folderName: 'Auto Ticket',
            tabName: 'Auto Ticket'
        };
        this.columnDefinitions = [
            {
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            },
            {
                id: 'ticketType', name: 'Ticket Type', field: 'ticketType', sortable: true, filterable: true
            },
            {
                id: 'category', name: 'Category', field: 'category', sortable: true, filterable: true
            },
            {
                id: 'ticket_title', name: 'Ticket Title', field: 'ticket_title', sortable: true, filterable: true, cssClass: 'highlight', editor: {
                    model: CustomInputEditor
                }
            },
            {
                id: 'ticket_description', name: 'Ticket Description', field: 'ticket_description', sortable: true, cssClass: 'highlight', filterable: true,
                editor: { model: CustomInputEditor }
            },
            {
                id: 'activity_type', name: 'Activity Type', field: 'activity_type', sortable: true, filterable: true
            },
            {
                id: 'activity_value', name: 'Activity Value', field: 'activity_value', sortable: true, filterable: true
            }

        ];
        this.messageService.setColumnDefinitions(this.columnDefinitions);
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                this.view = auth[0].viewFlag;
                this.add = auth[0].addFlag;
                this.edit = auth[0].editFlag;
                this.del = auth[0].deleteFlag;
                this.clientId = auth[0].clientId;
                this.baseFlag = auth[0].baseFlag;
                this.onPageLoad();
            });
        }
    }

    onPageLoad() {
        // this.getRequesterInfoDetails();
        this._rest.getTicketType(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                this.isError1 = false;
                this.respObject.details.unshift({ id: 0, name: 'Select Ticket Type' });
                this.ttypes = this.respObject.details;
                this.ticketSelected = 0;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });
        this.getTableData();
    }

    addMonthlyActivityDiv() {
        this.monthlyActivity.push({ 'month': 'Select month', 'date': 'Select day', 'time': '' });
    }

    addQuarterlyActivityDiv() {
        this.quarterlyActivity.push({ 'quarter': 'Select quarter', 'month': 'Select month', 'date': 'Select date', 'time': '' });
    }

    addActivityValue() {
        this.activityValue.push({ value: '' });
    }

    addSunTime() {
        this.sunValue.push({ value: '' });
    }

    addMonTime() {
        this.monValue.push({ value: '' });
    }

    addTueTime() {
        this.tueValue.push({ value: '' });
    }

    addWedTime() {
        this.wedValue.push({ value: '' });
    }

    addThuTime() {
        this.thuValue.push({ value: '' });
    }

    addFriTime() {
        this.friValue.push({ value: '' });
    }

    satFriTime() {
        this.satValue.push({ value: '' });
    }
    onQuarterChange(selectedIndex: any, id: any) {
        var qid = "Q" + id;
        var mid = "M" + id;

        var s1 = document.getElementById(qid).id;
        var s2 = document.getElementById(mid);
        s2.innerText = "";

        //  console.log(s1);
        //  console.log(s2);


        if (selectedIndex === 1) {
            var option1 = document.createElement("option");
            this.quarterlyMonth = ["Select Month|0", "January|1", "February|2", "March|3"];

            // this.quarterlyMonth = [{id: 0, name: 'Select month'}, {id: 1, name: 'January'}, {id: 2, name: 'February'},
            //     {id: 3, name: 'March'}];
        } else if (selectedIndex === 2) {
            this.quarterlyMonth = ["Select Month|0", "April|4", "May|5", "June|6"];
            // this.quarterlyMonth = [{id: 0, name: 'Select month'}, {id: 4, name: 'April'}, {id: 5, name: 'May'}, {id: 6, name: 'June'}];
        } else if (selectedIndex === 3) {
            this.quarterlyMonth = ["Select Month|0", "July|7", "August|8", "September|9"];
            // this.quarterlyMonth = [{id: 0, name: 'Select month'}, {id: 7, name: 'July'}, {id: 8, name: 'August'},
            //     {id: 9, name: 'September'}];
        } else if (selectedIndex === 4) {
            this.quarterlyMonth = ["Select Month|0", "October|10", "November|11", "December|12"];
            // this.quarterlyMonth = [{id: 0, name: 'Select month'}, {id: 10, name: 'October'}, {id: 11, name: 'November'},
            //     {id: 12, name: 'December'}];
        } else if (selectedIndex === 0) {
            this.quarterlyMonth = [];
        }
        for (var option in this.quarterlyMonth) {
            var pair = this.quarterlyMonth[option].split("|");
            var newOption = document.createElement("option");
            newOption.id = pair[1];
            newOption.value = pair[0];
            newOption.innerText = pair[0];

            s2.appendChild(newOption);
        }
    }
    onTicketChange(selectedIndex: any) {
        this.ticketTypeId = this.ttypes[selectedIndex].id;
        this.ticketType = this.ttypes[selectedIndex].name;
        this.ticketTypeSeq = this.ttypes[selectedIndex].seq;
        this.priority = '';
        this.priorityId = 0;

        this._rest.getSupportGroupByTicketTypeLt(this.ticketTypeId, this.clientId).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.respObject.details.unshift({ id: 0, name: 'Select support group' });
                this.support_group = this.respObject.details;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });
    }

    onSupportGroupChange(selectedIndex: any) {
        this._rest.getCreateTicketDataWithGroup(this.messageService.getUserId(), this.ticketTypeId, this.clientId, this.groupSelected).subscribe((res) => {
            this.respObject = res;
            this.categoryLoaded = true;
            if (this.respObject.success) {
                // this.baseCategories = JSON.parse(JSON.stringify(this.respObject.details[0].attribute));
                this.baseCategories = this.messageService.copyArray(this.respObject.details[0].attribute);
                this.ticketTypes = this.respObject.details[0].attribute;
                this.priorityType = this.respObject.details[0].val.type;
                this.disabledCount = this.respObject.details[0].disabled;
                this.cat = [];
                // this.clientId = this.respObject.details[0].clientId;
                this.respObject.details[0].val.urgency.unshift({
                    id: 0,
                    name: 'Select Urgency'
                });
                this.respObject.details[0].val.impact.unshift({
                    id: 0,
                    name: 'Select Bussiness Impact'
                });
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });

        this._rest.getUserByGroup(this.clientId, this.groupSelected).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.respObject.details.unshift({ id: 0, name: 'Select User' });
                this.users = this.respObject.details;
            } else {
                alert(this.respObject.errorMessage);
            }
        }, (err) => {
            // alert(this.messageService.SERVER_ERROR);
        });
    }

    onUserChange(selectedIndex: any) {
        this.userName = this.users[selectedIndex].login_name;
            console.log("im here 1========= >>>.");

        this._rest.getUserDetailsByLoginId(this.clientId, this.userName).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                // this.solutions = this.respObject.details;
                // this.createbyId = this.respObject.details[0].id;
                // this.name = this.empId + '-' + this.respObject.details[0].name;
                this.name = this.userName + '-' + this.messageService.xorEncode(atob(this.respObject.details[0].email), this.messageService.SECRET_TOKEN) +
                    '-' + this.messageService.xorEncode(atob(this.respObject.details[0].mobile), this.messageService.SECRET_TOKEN);
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    onActivityChange(selectedIndex: any) {
        this.activityTypeId = this.activityType[selectedIndex].id;
        if (this.activityTypeId < 3) {
            this.hideAddmore = false;
        } else {
            this.hideAddmore = true;
        }
        this.activityValue = [{ value: '' }];
        this.activityTypeName = this.activityType[selectedIndex].activity;
    }



    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }

    setFields() {
        this.description = '';
        this.ticketDesc = '';
        this.ticketTitle = '';
        this.ticketTypes = [];
        this.ticketSelected = 0;
        this.activityValue = [{ value: '' }];
        this.activityTypeId = 0;
        this.hideAddmore = true;
        this.activitySelected = 0;
        this.userSelected = 0;
        this.groupSelected = 0;
        this.quarterlyMonth = [];

        this.monthlyActivity = [{ 'month': 'Select month', 'date': 'Select date', 'time': '' }];

        this.quarterlyActivity = [{ 'quarter': 'Select quarter', 'month': 'Select month', 'date': 'Select date', 'time': '' }];
    }


    openModal(content) {
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {

            this.setFields();
            this.modalService.open(content, { size: 'lg' }).result.then((result) => {
            }, (reason) => {

            });
        }
    }

    onCategoryChange(ticket, option) {
        const opt = JSON.parse(option);
        if (opt.type !== 'header') {
            // if (this.attachment.length > 0) {
            //   this.attachment = [];
            // }
            const value = opt.id;
            const catTitle = opt.title;
            let matched = false;
            const index = this.ticketTypes.map(function (d) {
                return d['id'];
            }).indexOf(ticket.id + 1);
            // console.log('index:' + index, this.disabledCount);
            // console.log(typeof this.disabledCount, typeof index);
            const index1 = this.ticketTypes.map(function (d) {
                return d['id'];
            }).indexOf(ticket.id);
            const pid = this.ticketTypes[index1].options[0].id;
            // // console.log(this.ticketTypes[index1].options[0]);
            // console.log(index1);
            if (index1 === this.disabledCount) {
                // console.log('inside index'+this.cat.length);
                if (this.cat.length === 0) {
                    let pid1, cid1, title;
                    for (let i = 0; i < this.disabledCount; i++) {
                        pid1 = this.baseCategories[i].options[1].id;
                        cid1 = this.baseCategories[i].options[0].id;
                        title = this.baseCategories[i].options[0].title;
                        this.cat.push({ pid: pid1, cid: cid1, catName: title });
                    }
                }
                // const pid1 = this.baseCategories[0].options[1].id;
                // const pid2 = this.baseCategories[1].options[1].id;
                // const cid1 = this.baseCategories[0].options[0].id;
                // const cid2 = this.baseCategories[1].options[0].id;
                // if (this.cat.length === 0) {
                //     this.cat.push({pid: pid1, cid: cid1}, {pid: pid2, cid: cid2});
                // }
            }
            if (this.cat.length === 0) {
                this.cat.push({ pid: pid, cid: value, catName: catTitle });
            } else {
                for (let i = 0; i < this.cat.length; i++) {
                    if (this.cat[i].pid === pid) {
                        matched = true;
                        this.cat[i].cid = value;
                        break;
                    }
                }
                if (!matched) {
                    this.cat.push({ pid: pid, cid: value, catName: catTitle });
                } else {
                    for (let i = index; i < this.cat.length; i++) {
                        // // console.log('matched');
                        // // console.log(this.cat[i]);
                        if (index > -1) {
                            this.cat[i].cid = 0;
                        }
                    }
                }
            }
            // console.log(JSON.stringify(this.cat));
            // clear sub categories
            if (index > -1) {
                // console.log('index:' + index);
                for (let i = index + 1; i < this.ticketTypes.length; i++) {
                    const options = this.ticketTypes[i].options;
                    // console.log(JSON.stringify(options));
                    for (let j = 0; j < options.length; j++) {
                        if (options[j].type) {
                            // options=[];
                            this.ticketTypes[i].options = [options[j]];
                            break;
                        }
                    }
                }
            }

            let data;
            if (index > -1) {
                data = this.ticketTypes[index].options[0];
                this.ticketTypes[index].options = [];
            }

            let cats = '';
            const catsArr = [];
            for (let i = 0; i < this.cat.length; i++) {
                if (this.cat[i].cid !== 0) {
                    catsArr.push(this.cat[i]);
                    // categoryName += this.cat[i].pid + '#' + this.cat[i].cid;
                }
            }
            for (let i = 0; i < catsArr.length; i++) {
                if (catsArr[i].cid !== 0) {
                    if (i === catsArr.length - 1) {
                        cats += catsArr[i].cid;
                    } else {
                        cats += catsArr[i].cid + ',';
                    }
                    // categoryName += this.cat[i].pid + '#' + this.cat[i].cid;
                }
            }

            this._rest.getTicketFieldsCatWise({
                clientId: this.clientId,
                catId: cats,
                ticketTypeId: this.ticketTypeId
            }).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    // // console.log(JSON.stringify(this.respObject.details));
                    for (let i = 0; i < this.respObject.details.length; i++) {
                        if (this.respObject.details[i].predifinedValue !== null) {
                            this.respObject.details[i].values = this.respObject.details[i].predifinedValue.split(',');
                            this.respObject.details[i].value = this.respObject.details[i].values[0];
                        } else {
                            this.respObject.details[i].value = '';
                        }
                    }
                    this.dynamicFields = this.respObject.details;
                    // console.log(JSON.stringify(this.dynamicFields));
                } else {
                }
            }, (err) => {
            });


            this._rest.getAttributesParentWiseWithPriority(this.clientId, value, this.priorityType, this.ticketTypeId).subscribe((res) => {
                this.respObject = res;
                // // console.log(JSON.stringify(this.respObject));

                if (this.respObject.success) {
                    console.log('mmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmms');
                    // this.dataLoaded = true;
                    if (this.respObject.details.val) {
                        // data = this.ticketTypes[index].options[0];
                        this.respObject.details.val.unshift(data);
                        this.ticketTypes[index].options = this.respObject.details.val;
                    }
                    if (this.respObject.details.priority) {
                        this.priority = this.respObject.details.priority.name;
                        this.priorityId = this.respObject.details.priority.id;
                    }
                } else {
                    // this.dataLoaded = true;
                    if (index > -1) {
                        this.ticketTypes[index].options = [data];
                    }
                    // this.notifier.notify('error', this.respObject.errorMessage);
                }
            }, (err) => {
                this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
        }
    }



    blockSpecialChar(e) {
        const k = e.keyCode;
        return (k !== 35 && k !== 64);
    }
    timeFormat(date) {
        console.log(date);
        if (date !== null && date !== 0 && date !== undefined) {
            const d = new Date(date);
            // const hour = d.getUTCHours();
            // const min = d.getUTCMinutes();

            const hour = d.getHours();
            const min = d.getMinutes();


            console.log('utc min' + min);
            let nHour, nMin;
            if (hour < 10) {
                nHour = '0' + hour;
            } else {
                nHour = hour;
            }
            if (min < 10) {
                nMin = '0' + min;
            } else {
                nMin = min;
            }
            return nHour + ':' + nMin;
        } else {
            return '00:00';
        }


    }
    save() {
        let extrafields = '';
        let extraCount = 0;
        let isAddFieldMissing = false;
        let cats = '';
        let createTicketCat = '';
        let categoryName = '';
        let isError = false;
        let isError1 = false;
        let sunTime = '';
        let monTime = '';
        let tueTime = '';
        let wedTime = '';
        let thuTime = '';
        let friTime = '';
        let satTime = '';
        const assetIds = [];
        let activity = '';
        const activityArr = [];
        console.log('cat===' + JSON.stringify(this.activityValue) + '=================' + this.activityTypeId);

        for (let i = 0; i < this.activityValue.length; i++) {
            if (this.activityTypeId === 1) {
                console.log('SSSSSSSSSSSSSS' + this.activityValue[i].value);
                activity += this.activityValue[i].value + ',';
            } else if (this.activityTypeId === 2) {

                if (this.activityValue[i].value !== null && this.activityValue[i].value !== '') {
                    activity += this.timeFormat(this.activityValue[i].value) + ',';
                } else {
                    isError1 = true;
                }
            }
        }
        activity = activity.substring(0, activity.length - 1);

        console.log('activity ============ >>>>>>', activity);


        if (this.activityTypeId === 3) {
            if (this.sunChck === true) {
                for (let i = 0; i < this.sunValue.length; i++) {
                    if (this.sunValue[i].value !== '') {
                        sunTime += this.timeFormat(this.sunValue[i].value) + ',';
                    } else {
                        isError1 = true;


                    }
                }
                sunTime = sunTime.substring(0, sunTime.length - 1);
                activityArr.push({ 'sunday': this.sunChck, 'time': sunTime });
            }

            if (this.monChck === true) {
                for (let i = 0; i < this.monValue.length; i++) {
                    if (this.monValue[i].value !== '') {
                        monTime += this.timeFormat(this.monValue[i].value) + ',';
                    } else {
                        isError1 = true;
                    }
                }
                monTime = monTime.substring(0, monTime.length - 1);
                activityArr.push({ 'monday': this.monChck, 'time': monTime });
            }

            if (this.tueChck === true) {
                for (let i = 0; i < this.tueValue.length; i++) {
                    if (this.tueValue[i].value !== '') {
                        tueTime += this.timeFormat(this.tueValue[i].value) + ',';
                    } else {
                        isError1 = true;
                    }
                }
                tueTime = tueTime.substring(0, tueTime.length - 1);
                activityArr.push({ 'tuesday': this.tueChck, 'time': tueTime });
            }

            if (this.wedChck === true) {
                for (let i = 0; i < this.wedValue.length; i++) {
                    if (this.wedValue[i].value !== '') {
                        wedTime += this.timeFormat(this.wedValue[i].value) + ',';
                    } else {
                        isError1 = true;
                    }
                }
                wedTime = wedTime.substring(0, wedTime.length - 1);
                activityArr.push({ 'wednesday': this.wedChck, 'time': wedTime });
            }

            if (this.thurChck === true) {
                for (let i = 0; i < this.thuValue.length; i++) {
                    if (this.thuValue[i].value !== '') {
                        thuTime += this.timeFormat(this.thuValue[i].value) + ',';
                    } else {
                        isError1 = true;
                    }
                }
                thuTime = thuTime.substring(0, thuTime.length - 1);
                activityArr.push({ 'thursday': this.thurChck, 'time': thuTime });
            }

            if (this.friChck === true) {
                for (let i = 0; i < this.friValue.length; i++) {
                    if (this.friValue[i].value !== '') {
                        friTime += this.timeFormat(this.friValue[i].value) + ',';
                    } else {
                        isError1 = true;
                    }

                }
                friTime = friTime.substring(0, friTime.length - 1);
                activityArr.push({ 'friday': this.friChck, 'time': friTime });
            }


            if (this.satChck === true) {
                for (let i = 0; i < this.satValue.length; i++) {
                    if (this.satValue[i].value !== '') {
                        satTime += this.timeFormat(this.satValue[i].value) + ',';
                    } else {
                        isError1 = true;
                    }
                }
                satTime = satTime.substring(0, satTime.length - 1);
                activityArr.push({ 'saturday': this.satChck, 'time': satTime });
            }
            console.log('sunTime===============' + JSON.stringify(activityArr));
            if (activityArr.length !== 0) {
                activity = JSON.stringify(activityArr);

                console.log('activity4444===============' + JSON.stringify(activityArr));

            } else {
                isError1 = true;


            }

        }
        if (this.activityTypeId === 4) {
            for (let i = 0; i < this.monthlyActivity.length; i++) {
                if (this.monthlyActivity[i].time !== '' && this.monthlyActivity[i].month !== 'Select month') {
                    this.monthlyActivity[i].time = this.timeFormat(this.monthlyActivity[i].time);

                } else {
                    isError1 = true;
                }

            }
            if (this.monthlyActivity.length !== 0) {
                activity = JSON.stringify(this.monthlyActivity);
                console.log('activity 123== >>>> ' + JSON.stringify(activity));
            } else {
                isError1 = true;

            }


        } else if (this.activityTypeId === 5) {
            for (let i = 0; i < this.quarterlyActivity.length; i++) {

                if (this.quarterlyActivity[i].time !== '' && this.quarterlyActivity[i].month !== 'Select month' && this.quarterlyActivity[i].date !== 'Select day') {
                    this.quarterlyActivity[i].time = this.timeFormat(this.quarterlyActivity[i].time);
                } else {
                    isError1 = true;

                }
                console.log("aaaaaaaaaa" + JSON.stringify(this.quarterlyActivity));

            }
            if (this.quarterlyActivity.length !== 0) {
                activity = JSON.stringify(this.quarterlyActivity);
                console.log('activity == >>>> ' + JSON.stringify(activity));

            } else {
                isError1 = true;

            }

        }



        if (this.cat.length === this.ticketTypes.length) {
            for (let i = 0; i < this.cat.length; i++) {
                if (this.cat[i].cid !== 0) {
                    cats += this.cat[i].cid;
                    if (i !== this.cat.length - 1) {
                        cats += ',';
                    }
                    if (categoryName === '') {
                        categoryName = this.cat[i].catName;
                    } else {
                        categoryName += ' / ' + this.cat[i].catName;
                    }
                    categoryName += this.cat[i].pid + '#' + this.cat[i].cid;
                } else {
                    isError = true;
                    break;
                }
            }

            for (let i = 0; i < this.cat.length; i++) {
                if (this.cat[i].cid !== 0) {
                    createTicketCat += this.cat[i].pid + '#' + this.cat[i].cid;
                    if (i !== this.cat.length - 1) {
                        createTicketCat += ',';
                    }
                } else {
                    isError = true;
                    break;
                }
            }
        } else {
            isError = true;
        }

        for (let i = 0; i < this.dynamicFields.length; i++) {
            if (this.dynamicFields[i].value !== '') {
                extraCount++;
                if (i === this.dynamicFields.length - 1) {
                    extrafields += this.dynamicFields[i].id + '@' + this.dynamicFields[i].value;
                } else {
                    extrafields += this.dynamicFields[i].id + '@' + this.dynamicFields[i].value + '#';
                }
            }
        }
        if (extraCount !== this.dynamicFields.length) {
            isAddFieldMissing = true;
        }
        extrafields = extrafields.substring(extrafields.length - 1, extrafields.length) === '#'
            ? extrafields.substring(0, extrafields.length - 1) : extrafields;

        // =================================create ticket data=============================================
        let create_ticket_data;
        const sourceType = this.messageService.getSourceType();
        if (sourceType !== null) {
            this.sourceType = sourceType;
        } else {
            this.sourceType = 'CIT Portal';
        }
        if (isError) {
            this.isError = true;
            this.errorMessage = this.messageService.CATEGORY_ERROR;
        } else if (isError1) {
            this.isError1 = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        } else {
            if (this.priorityType === 1) {
                console.log("im her 2");

                create_ticket_data = {
                    'ticket_type_seq': this.ticketTypeSeq,
                    'clientId': this.clientId,
                    'user_id': this.userSelected,
                    'ticketTypeId': this.ticketTypeId,
                    // 'requesterInfo': this.name,
                    'tName': this.ticketTitle,
                    'longDesc': this.ticketDesc,
                    'attachmentPath': [],
                    'busi_priority_id': this.priorityId,
                    'tstatus': 1,
                    // 'requestedDate': this.rDate,
                    // 'dueDate': this.dDate,
                    // 'busi_impact_id': this.impact,
                    // 'busi_urgency_id': this.urgency,
                    'createdBy': this.userSelected,
                    'categoryDtlsLt': createTicketCat,
                    'priorityType': this.priorityType,
                    'sourceType': this.sourceType,
                    'original_createdbyid': this.userSelected,
                    'userGroupId': this.groupSelected,
                    'fieldValueDtls': extrafields,
                    'requesterInfo': this.name,
                    'ps-no': this.userName
                };
            } else if (this.priorityType === 2) {
                console.log("im her 3");

                create_ticket_data = {
                    'ticket_type_seq': this.ticketTypeSeq,
                    'clientId': this.clientId,
                    'user_id': this.userSelected,
                    'ticketTypeId': this.ticketTypeId,
                    // 'requesterInfo': this.name,
                    'tName': this.ticketTitle,
                    'longDesc': this.ticketDesc,
                    'attachmentPath': [],
                    'busi_priority_id': this.priorityId,
                    'tstatus': 1,
                    // 'requestedDate': this.rDate,
                    // 'dueDate': this.dDate,
                    'createdBy': this.userSelected,
                    'categoryDtlsLt': createTicketCat,
                    'priorityType': this.priorityType,
                    'sourceType': this.sourceType,
                    'original_createdbyid': this.userSelected,
                    'userGroupId': this.groupSelected,
                    'fieldValueDtls': extrafields,
                    'requesterInfo': this.name,
                    'ps-no': this.userName
                };
            }
            // ======================================================================================================
            console.log('data before activity ====activity');

            const data = {
                client_id: this.clientId,
                ticketType: this.ticketSelected,
                category: cats,
                ticketTitle: this.ticketTitle,
                ticketDescription: this.ticketDesc,
                activityValue: activity,
                activityTypeId: this.activitySelected,
                activityType: this.activityTypeName,
                create_ticket_data: JSON.stringify(create_ticket_data),
                createdBy: this.userSelected,
                groupId: this.groupSelected
            };
            console.log('data before====' + JSON.stringify(data));
            console.log('this.activityValue[0].value===' + this.activityValue[0].value + '=================' + this.activityTypeId);
            if (!this.messageService.isBlankField(data) && ((data.activityValue !== '' || this.activityValue.length > 0) && this.activityTypeId < 6)) {
                if (extrafields !== '') {
                    data['fieldValueDtls'] = extrafields;
                }
                console.log('data====' + JSON.stringify(data));
                this._rest.insertAutoTicket(data).subscribe((res) => {
                    this.respObject = res;
                    if (this.respObject.success) {
                        this.isError = false;
                        const id = this.respObject.details;
                        this.messageService.setRow({
                            id: id,
                            ticketType: this.ticketType,
                            category: categoryName,
                            ticket_title: this.ticketTitle,
                            ticket_description: this.ticketDesc,
                            activity_type: this.activityTypeName,
                            activity_value: activity
                        });
                        this.totalData = this.totalData + 1;
                        this.messageService.setTotalData(this.totalData);
                        if (this.totalData <= this.pageSize * this.page_no) {
                            this.offset = id;
                            this.nextOffset = 0;
                        } else {
                            this.nextOffset = this.offset;
                        }
                        this.ticketSelected = 0;
                        this.ticketDesc = '';
                        this.ticketTitle = '';
                        this.activityTypeId = 0;
                        this.activitySelected = 0;
                        this.hideAddmore = true;
                        this.userSelected = 0;
                        this.groupSelected = 0;
                        this.sunChck = false;
                        this.monChck = false;
                        this.tueChck = false;
                        this.wedChck = false;
                        this.thurChck = false;
                        this.friChck = false;
                        this.satChck = false;
                        this.sunValue = [{ value: '' }];
                        this.monValue = [{ value: '' }];
                        this.tueValue = [{ value: '' }];
                        this.wedValue = [{ value: '' }];
                        this.thuValue = [{ value: '' }];
                        this.friValue = [{ value: '' }];
                        this.satValue = [{ value: '' }];
                        this.cat = [];
                        this.dynamicFields = [];
                        this.name = '';
                        this.ticketTypes = [];

                        this.setFields();


                    } else {
                        this.isError = true;
                        this.errorMessage = this.respObject.errorMessage;
                    }
                }, (err) => {
                    this.isError = true;
                    this.errorMessage = this.messageService.SERVER_ERROR;
                });
            } else {
                this.isError = true;
                this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
            }
        }
    }

    getTableData() {
        // console.log(this.messageService.view)
        if (!this.messageService.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.getData({ 'offset': this.nextOffset, 'paginationType': '' });
        }
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded = false;
        this._rest.getAutoTicket(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            // console.log(this.respObject)
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded = true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({ 'offset': this.nextOffset, 'paginationType': '' });
    }

    ngOnDestroy(): void {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }
    }


    c() {
        this.myModal.close();
    }
}
